import React from "react"
import { graphql } from "gatsby"

import Layout from "../layouts"

class NotFoundPage extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title

    return (
      <Layout title={siteTitle} description="Страница не найдена" keywords="Спортивная страховка">
        <h1>Страница не найдена</h1>
        <p>По этому адресу ничего нет</p>
      </Layout>
    )
  }
}

export default NotFoundPage

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
      }
    }
  }
`
